import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { AppSettings } from '../app.settings';

@Injectable({
  providedIn: 'root'
})
export class FixedInventoryService {

  constructor(private http: HttpClient) { }

   isRequestedQuantityAvailable(horse_show_id: string, billing_code: string, quantity: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
     return this.http.get(AppSettings.API_ENDPOINT + 'accounting/fixed_inventory/is_quantity_available/horse_show_id/' + horse_show_id +'/billing_code/' + billing_code + '/quantity/' + quantity).subscribe((response:any) => {
      if(response.type == 'requested_quantity_available' && (response.data == true || response.data == false)){
        resolve(response.data);
        } else {
          reject(response);
        }

      }, error_response => {
            if(error_response instanceof HttpErrorResponse){
              reject(error_response.error);
            } else {
              reject(error_response);
            }
    });

   });

  }

}
